module.exports = __webpack_public_path__ + "static/media/OnlineTask.fb1cc30d.svg";